export default __webpack_public_path__ + "static/media/hero-video-compressed-new.62a6cb0e.mp4";